// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YVZN475YX_QemCDjwe3Q{background:var(--border-neutral-default);border:1px solid var(--border-neutral-default);border-radius:8px;grid-template-columns:1fr 1fr 1fr 1fr 2fr;grid-template-areas:"messages messages calls calls credits""messagesIn messagesOut callsIn callsOut credits";gap:1px;margin:0 20px 20px;display:grid;overflow:hidden}.evSaqTEbkLUjdC0eTWtO{background:var(--background-primary-inverted-primary);flex-direction:column;gap:11px;padding:28px 20px 20px;display:flex}.nCh8eg9PlYKf67Xa6KlP{padding-top:20px}.hUqBXcefcFkk1j7xkqJ0{grid-area:messages}.PL33gSVKZwmda7vowMdO{grid-area:calls}.t8gajM66o836TZUd817I{grid-area:credits}.bYWBjz3SANwdEh28s4N1{grid-area:messagesIn}.drnyTLYsCh4MJ8ZGloAv{grid-area:messagesOut}.yM8dBewP4gAqh3Zm6tFs{grid-area:callsIn}.qkt8VIlZvhEF7Z1LjV_r{grid-area:callsOut}.PpTP9KuyKUhW3ypgdLP4{height:200px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grid": `YVZN475YX_QemCDjwe3Q`,
	"cell": `evSaqTEbkLUjdC0eTWtO`,
	"cellSmall": `nCh8eg9PlYKf67Xa6KlP`,
	"messages": `hUqBXcefcFkk1j7xkqJ0`,
	"calls": `PL33gSVKZwmda7vowMdO`,
	"credits": `t8gajM66o836TZUd817I`,
	"messagesIn": `bYWBjz3SANwdEh28s4N1`,
	"messagesOut": `drnyTLYsCh4MJ8ZGloAv`,
	"callsIn": `yM8dBewP4gAqh3Zm6tFs`,
	"callsOut": `qkt8VIlZvhEF7Z1LjV_r`,
	"totalSpinner": `PpTP9KuyKUhW3ypgdLP4`
};
export default ___CSS_LOADER_EXPORT___;
